"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToggleButton_1 = require("./ToggleButton");
exports.default = ToggleButton_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/ToggleButton/index.js
// module id = 1374
// module chunks = 8